import { BOOLEAN_STRING } from './constants';

export const ARIA = Object.freeze({
  EXPANDED: 'aria-expanded',
  HIDDEN: 'aria-hidden',
});

// Expanded
export const isAriaExpanded = element =>
  element.getAttribute(ARIA.EXPANDED) === BOOLEAN_STRING.TRUE;

export const setAriaIsExpanded = element =>
  element.setAttribute(ARIA.EXPANDED, BOOLEAN_STRING.TRUE);

export const setAriaIsNotExpanded = element =>
  element.setAttribute(ARIA.EXPANDED, BOOLEAN_STRING.FALSE);

export const toggleAriaExpanded = element => {
  const isExpanded = isAriaExpanded(element);
  isExpanded ? setAriaIsNotExpanded(element) : setAriaIsExpanded(element);
  return isExpanded;
};

// Hidden
export const isAriaHidden = element =>
  element.getAttribute(ARIA.HIDDEN) === BOOLEAN_STRING.TRUE;

export const setAriaIsHidden = element =>
  element.setAttribute(ARIA.HIDDEN, BOOLEAN_STRING.TRUE);

export const setAriaIsNotHidden = element =>
  element.setAttribute(ARIA.HIDDEN, BOOLEAN_STRING.FALSE);

export const toggleAriaHidden = element => {
  const isHidden = isAriaHidden(element);
  isHidden ? setAriaIsNotHidden(element) : setAriaIsHidden(element);
  return isHidden;
};
